import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ActionStatusType} from "../../../common/enums/enums";
import {Localization} from '../../../common/enums/localization';
import {Router} from "@angular/router";
import {AppConfig} from "../../../../config/app.config";
import {ActionContextualMenuComponent} from "../interaction/action-contextual-menu/action-contextual-menu.component";
import {MatMenuTrigger} from '@angular/material/menu';
import {InterventionTeamDetailDto} from '../../intervention-teams/teams/intervention-team-detail.dto';
import {Action} from '../../../common/model/action';

@Component({
  selector: 'app-draggable-action',
  templateUrl: './draggable-action.component.html',
  styleUrls: ['./draggable-action.component.scss'],
})
export class DraggableActionComponent {
  public readonly Localization = Localization;
  @Input() model: Action;
  @Input() assignableActionStatuses: ActionStatusType[] = [];
  @Input() subTitle = ActionSubTitle.InterventionTeam;
  @Input() statusColorMap = ActionStatusColorMap;
  @Input() selectable = false;
  @Input() teams: InterventionTeamDetailDto[];
  @Input()
  public selected = false;
  @ViewChild(ActionContextualMenuComponent)
  public menu: ActionContextualMenuComponent;
  @ViewChild(MatMenuTrigger)
  public trigger: MatMenuTrigger;
  @Output()
  public delete = new EventEmitter<Action>();
  @Output()
  public assign = new EventEmitter<[Action, InterventionTeamDetailDto]>();
  @Output()
  public clicked = new EventEmitter<[Action, MouseEvent]>();

  constructor(private router: Router, public config: AppConfig) {
  }

  public get elementLabel(): string {
    return this.model.issues[0].elementStructureLabel;
  }

  public get issueLocation(): string {
    const issueLocationPath = this.model.issues[0]?.issueLocationPath || '';
    return reverseLocationPath(issueLocationPath);
  }

  public get fullLocationLabel(): string {
    return [
      this.issueLocation,
      this.elementLabel,
    ].filter(Boolean).join(' / ');
  }

  public get shouldShowLocation(): boolean {
    return this.desiredSubtitleIs(ActionSubTitle.Location)
        && this.issueLocation.length > 0;
  }

  public get shouldShowBuilding(): boolean {
    return this.desiredSubtitleIs(ActionSubTitle.Building)
        && this.model.issues[0]?.issueBuildingLabel.length > 0;
  }

  public get shouldShowTeam(): boolean {
    return this.desiredSubtitleIs(ActionSubTitle.InterventionTeam)
        && this.model.interventionTeam?.label.length > 0;
  }


  public get checkboxId(): string {
    return `checkbox-${this.model.id}`;
  }

  public get localisableActionType(): string {
    return `actionType_${this.model.type}`;
  }

  public get textClassForStatus(): string {
    return ActionStatusColorMap.get(this.model.status) || '';
  }

  public get isUnassigned(): boolean {
    return this.model.status === ActionStatusType.OPEN && !this.model.interventionTeamId;
  }

  public toggleMenu(event: Event) {
    event.stopPropagation();
    if (this.isUnassigned) {
      this.trigger.toggleMenu();
    }
  }

  public desiredSubtitleIs(subtitle: ActionSubTitle) {
    return this.subTitle === subtitle;
  }
}

export const ActionStatusColorMap = new Map<ActionStatusType, string>([
  [ActionStatusType.OPEN, 'text-muted'],
  [ActionStatusType.SENT, 'text-warning'],
  [ActionStatusType.EXECUTING, 'text-warning'],
  [ActionStatusType.ACCEPTED, 'text-success'],
]);

export enum ActionSubTitle {
  Building = 'Building',
  InterventionTeam = 'InterventionTeam',
  Location = 'Location'
}

function reverseLocationPath(issueLocationPath: string): string {
  return issueLocationPath.split('/')
    .map(segment => segment.trim())
    .reverse()
    .join(' / ');
}
